import { render } from "./B2bPageGenralsReceived.vue?vue&type=template&id=55566214&scoped=true&lang=pug"
import script from "./B2bPageGenralsReceived.vue?vue&type=script&lang=js"
export * from "./B2bPageGenralsReceived.vue?vue&type=script&lang=js"

import "./B2bPageGenralsReceived.vue?vue&type=style&index=0&id=55566214&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55566214"]])

export default __exports__